<div [formGroup]="hakkomotoForm">
<mat-card-content>
  <mat-card-header>
    <mat-card-title>発行元</mat-card-title>
    <mat-icon></mat-icon>
  </mat-card-header>
  <div fxLayout="row wrap" fxLayoutAlign="start center">
    <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="30">
      <mat-label>郵便番号</mat-label>
      <input matInput
        formControlName="hakkomotoPostno"
        autocomplete="off"
        (blur)="onBlurZipcode()"
        (focus)="onFocusZipcode()"
      />
    </mat-form-field>
    <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="30">
      <mat-label>住所</mat-label>
      <input matInput
        formControlName="hakkomotoAddr"
        autocomplete="off" />
    </mat-form-field>
  </div>
  <div fxLayout="row wrap" fxLayoutAlign="start center">
    <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="30">
      <mat-label>問い合わせ窓口</mat-label>
      <input matInput
        formControlName="contactMadoguchi"
        autocomplete="off" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="30">
      <mat-label>電話番号</mat-label>
      <input matInput
        formControlName="hakkomotoTelno"
        autocomplete="off" />
    </mat-form-field>
  </div>
</mat-card-content>
<mat-card-content>
  <div fxLayout="row wrap" fxLayoutAlign="end center">
    <mat-card-actions class="btn_area_right">
      <button type="button" mat-raised-button
        [disabled]="false"
        color="primary"
        class="btn btnHokkomotoClear"
        (click)="onClickClear()">クリア</button>
    </mat-card-actions>
  </div>
</mat-card-content>
</div>